import { LOCATION_FILTER_KEYS } from '@/lib/api/common/locationTableFilters';
import { RESOURCE_FILTER_KEYS } from '@/lib/api/common/resourceTableFilters';
import { TEAMS_PICKLIST_FILTERS } from '@/lib/api/common/teamsTableFilters';
import { TEAM_FILTER_KEYS } from '@/lib/api/common/teamTableFilters';
import {
  BOOLEAN_FILTERS,
  type CompactFilterKey,
  DATE_FILTERS,
  FILTER_KEYS,
  INSIGHTS_FILTER_KEYS,
  type InsightsFilterKey,
  PICKLIST_FILTERS,
  type ResourceFilterKey,
  type TeamFilterKey,
  type TeamsFilterKey,
} from './filterKeyTypes';

export const isInsightsFilterKey = (key: string): key is InsightsFilterKey => {
  return INSIGHTS_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isLocationFilterKey = (key: string): key is (typeof LOCATION_FILTER_KEYS)[number] => {
  return LOCATION_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isResourceFilterKey = (key: string): key is ResourceFilterKey => {
  return RESOURCE_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isTeamsFilterKey = (key: string): key is TeamsFilterKey => {
  return TEAMS_PICKLIST_FILTERS.some((filterKey) => filterKey === key);
};

export const isTeamFilterKey = (key: string): key is TeamFilterKey => {
  return TEAM_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isCompactFilterKey = (key: string): key is CompactFilterKey => {
  return FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isPicklistFilterKey = (
  key: CompactFilterKey,
): key is (typeof PICKLIST_FILTERS)[number] => {
  return PICKLIST_FILTERS.some((filterKey) => filterKey === key);
};

export const isDateFilterKey = (key: CompactFilterKey): key is (typeof DATE_FILTERS)[number] => {
  return DATE_FILTERS.some((filterKey) => filterKey === key);
};

export const isBooleanFilterKey = (
  key: CompactFilterKey,
): key is (typeof BOOLEAN_FILTERS)[number] => {
  return BOOLEAN_FILTERS.some((filterKey) => filterKey === key);
};
